import { useMutation, useQueryClient } from "@tanstack/react-query";
import { dropinApi } from "@bw/shared/api";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * Leave the court the caller is currently on (POST
 * /facilities/{id}/drop-in/courts/{courtId}/leave → void). The backend requires
 * the caller to be a member of that court.
 *
 * On settlement the board cache is invalidated so success and stale-state
 * rejection both re-read the server's truth — never an optimistic local flip.
 */
export function useLeaveCourt(facilityId: string) {
  const queryClient = useQueryClient();
  return useMutation<void, unknown, string>({
    mutationFn: (courtId: string) => dropinApi.leaveCourt(facilityId, courtId),
    onSettled: () => {
      void queryClient.invalidateQueries({
        queryKey: queryKeys.dropin.courtBoard(facilityId),
        refetchType: "active",
      });
      void queryClient.invalidateQueries({
        queryKey: ["dropin", "my-entry", facilityId],
        refetchType: "active",
      });
      void queryClient.invalidateQueries({
        queryKey: queryKeys.dropin.myParty(facilityId),
        refetchType: "active",
      });
      void queryClient.invalidateQueries({
        queryKey: queryKeys.dropin.partyMemberships(facilityId),
        refetchType: "active",
      });
    },
  });
}
